module.exports = __webpack_public_path__ + "static/media/joker.02a17683.webp";